<template>
    <!-- 产品试用说明路由 -->
    <div class="instructions-box">
        <div class="container">
            <!-- 搜索框 -->
            <div class="instructions-search-box">
                <el-input 
                    v-model="search"
                    :placeholder="$t('message.instructions.search')"
                    @keyup.enter.native="handleSearch"
                    clearable>
                    <el-button 
                        slot="append" 
                        icon="el-icon-search"
                        @click="handleSearch"></el-button>
                </el-input>
            </div>
            <!-- 列表 -->
            <div class="instructions-list-box">
                <el-row :gutter="20" v-if="instr_list.length>0">
                    <el-col :span="6" v-for="item in instr_list" :key="item.id">
                        <el-card shadow="hover" :body-style="{ padding: '0px' }">
                            <!-- 图片 -->
                            <router-link :to="{name: 'instrdetail', query:{id: item.id}}" class="instructions-list-img">
                                <img :src="item.image" alt="">
                            </router-link>
                            <div class="instructions-list-text">
                                <!-- 标题 -->
                                <router-link :to="{name: 'instrdetail', query:{id: item.id}}" class="instructions-list-title">
                                    {{item.title}}
                                </router-link>
                                <!-- 副标题 -->
                                <div class="instructions-list-subtitle">
                                    {{item.subtitle}}
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <div class="no-more" v-else>{{$t("message.instructions.nomore")}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
    data() {
        return {
            // 搜索框绑定数据
            search: "",
        }
    },
    computed: mapState({
        instr_list: state => state.instructions.instr_list,
    }),
    methods: {
        ...mapMutations([
            "setInstructionsList"
        ]),
        ...mapActions([
            "getInstructionsList",
        ]),
        // 搜索框
        handleSearch(){
            this.getInstructionsList({
                search: this.search
            });
        },
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.getInstructionsList({
                search: vm.search
            })
        })
    },
    beforeRouteLeave (to, from, next) {
        this.setInstructionsList([]);
        next();
    }
}
</script>

<style scoped>
/* element-ui */
.instructions-search-box>.el-input{
    width: 500px;
}
.instructions-list-box .el-col{
    margin-bottom: 20px;
}

/* 产品试用盒子 */
.instructions-box{
    /* margin-top: 151px; */
    margin: 30px 0;
}
/* 搜索框盒子 */
.instructions-search-box{
    text-align: right;
    margin: 20px 0;
}
/* 列表盒子 */
.instructions-list-box{
    padding: 20px;
    /* background-color: #fff; */
}
/* 列表图片 */
.instructions-list-img{
    position: relative;
    display: block;
    width: 100%;
}
.instructions-list-img::before{
    display: block;
    content: "";
    padding-top: 70%;
}
.instructions-list-img>img{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    max-width: 100%;
    max-height: 100%;
}
.instructions-list-text{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100px;
    padding: 20px;
}
/* 标题 */
.instructions-list-title{
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
    font-size: 14px;
    color: #333;
}
/* 副标题 */
.instructions-list-subtitle{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-size: 12px;
    color:#b0b0b0;
}
/* 没有更多 */
.no-more{
    text-align: center;
    padding: 50px 0;
}
</style>
